import React from 'react';
import uuid from 'uuid-random';
import PropTypes from 'prop-types';
import { TableContainer, Table, Thead, Tbody, Tr, Td } from './styles';

const TableComponent = ({ columnNames, columnsValues, dataPanel, device }) => {
  return (
    <TableContainer>
      <Table data-panel={`table-${dataPanel}`}>
        <Thead data-panel={`table-thead-${dataPanel}`}>
          <Tr data-panel={`table-thead-tr-${dataPanel}`}>
            {columnNames.map(header => {
              return (
                <Td key={uuid()} data-panel={`table-thead-td-${dataPanel}`} device={device}>
                  {header.label}
                </Td>
              );
            })}
          </Tr>
        </Thead>
        <Tbody data-panel={`table-tbody-${dataPanel}`} device={device}>
          {columnsValues.map(columnValue => (
            <Tr data-panel={`table-tbody-tr-${dataPanel}`} key={uuid()}>
              {columnNames.map(header => (
                <Td
                  key={uuid()}
                  data-panel={`table-tbody-td-${dataPanel}`}
                  device={device}
                  columnName={header.accessor}
                >
                  {columnValue[header.accessor]}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

TableComponent.propTypes = {
  columnNames: PropTypes.arrayOf(PropTypes.shape({ accessor: PropTypes.string, label: PropTypes.string })).isRequired,
  columnsValues: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.object, mail: PropTypes.string, permissions: PropTypes.object })
  ).isRequired,
  dataPanel: PropTypes.string.isRequired
};

export default TableComponent;
